import { r2Fetch } from './client';

export interface R2FileDeleteParams {
  bucket_id: string;
  key: string;
  if_match?: string;
}

export async function r2FileDelete(
  params: R2FileDeleteParams
): Promise<{ success: boolean }> {
  return r2Fetch<{ success: boolean }>('/rpc/r2_file_delete', { body: params });
}
